import {Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name: 'setCommaPipe'
})
export class SetCommaPipe implements PipeTransform {
  transform (value: any): any {
    if (!value) return value;
    const removeComma = value && value.toString().replace(/,/g, '');
    if (!removeComma) return value;
    let replacedNumber;
    if(removeComma.indexOf('.') > -1 && removeComma.split('.')[1].length > 2) {
      replacedNumber = Number(removeComma).toFixed(2);
    } else {
      replacedNumber = removeComma;
    }
    return String(replacedNumber).replace(/\B(?=(\d{3})+(?!\d))/g,",");
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/set-comma-pipe.ts